import {
  type IConversationRepository,
  type ConversationStreamHandlers,
} from '../../interfaces/IConversationRepository'
import { type ConversationTechnicalMessagePayload } from '../../types/ConversationTechnicalMessagePayload'

interface Dependency {
  conversationRepository: IConversationRepository
}

export class SendConversationTechnicalMessageUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = (
    payload: ConversationTechnicalMessagePayload,
    handlers: ConversationStreamHandlers
  ): (() => void) =>
    this.deps.conversationRepository.sendTechnicalMessage(payload, handlers)
}
